/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupFormConfiguration
 */
export interface AgencyGroupFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof AgencyGroupFormConfiguration
     */
    brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function AgencyGroupFormConfigurationFromJSON(json: any): AgencyGroupFormConfiguration {
    return AgencyGroupFormConfigurationFromJSONTyped(json, false);
}

export function AgencyGroupFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function AgencyGroupFormConfigurationToJSON(value?: AgencyGroupFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
    };
}


